import React from 'react';
import './Products.css';

const productList = [
  { name: 'Vannamei Prawn', image: '/images/product3.jpg' },
  { name: 'Pomfret Fish', image: '/images/pamplate_fish.jpeg' },
  { name: 'Black Tiger Prawn', image: '/images/product2.jpg' },
  { name: 'Catla Fish', image: '/images/Catla_fish.jpg' },
  { name: 'Rohu Fish', image: '/images/rohu_fish.jpg' },
  { name: 'Grasscrap Fish', image: '/images/Grasscrap Fish.jpg' },
  { name: 'Scampi Prawn', image: '/images/scampi_prawn.jpg' },
  { name: 'Barramundi Fish', image: '/images/pangasius_fish.jpg' },
  { name: 'Karikadi Prawn', image: '/images/Karikadi.jpg' },
  { name: 'Koramina Fish', image: '/images/koramina_fish.jpg' }
];

function Products() {
  return (
    <div className="products-page">
      {/* Hero Section */}
      <div className="about-hero-image">
        <img src="/images/products-hero.png" alt="Product Showcase" />
      </div>

      {/* Intro Content */}
      <section className="about-content-section">
        <h2>Our Products</h2>
        <p>
          At Sharanga Aqua Farms, we offer a wide range of high-quality seafood including shrimp and fish varieties.
          Each product is processed under strict hygiene standards and meets export-grade quality assurance.
        </p>
      </section>

      {/* Product Grid */}
      <div className="product-grid">
        {productList.map((item, index) => (
          <div className="product-card" key={index}>
            <img src={item.image} alt={item.name} />
            <h4>{item.name}</h4>
          </div>
        ))}
      </div>

      {/* Bottom Info */}
      <section className="aqua-info-section">
        <h3>Committed to Aquaculture Excellence</h3>
        <p>
          Our aquaculture operations are built on sustainable practices, eco-friendly feed, and quality control.
          We aim to deliver freshness from pond to plate.
        </p>
      </section>
    </div>
  );
}

export default Products;
